<template>
  <div class="container">
    <el-container style="height: 100%;min-height:100vh; padding: 0px;" direction="vertical">
      <el-header class='header flex' height="60px">
        <span class="i-title">订单发货管理系统</span>
        <section class="flex">
          <span class="userName" v-if="0">管理员名称</span>
          <span type="text" disabled class="exit" @click="modifyPsw">修改密码</span>
          <span type="text" disabled class="exit" @click="exitSystem">退出系统</span>
        </section>
      </el-header>
      <el-container>
        <el-aside v-bind:style="{height:asideHeight}" width="158px" style="display: flex; justify-content: center;">
          <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @select="menuSelected">
            <el-menu-item index="1">
              <i class="el-icon-menu"></i>
              <span slot="title">益爱宁订单</span>
            </el-menu-item>
            <el-menu-item index="2">
              <i class="el-icon-menu"></i>
              <span slot="title">益普星订单</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-menu"></i>
              <span slot="title">拓普健康订单</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-menu"></i>
              <!-- <span slot="title">陆点壹订单</span> -->
              <span slot="title">牙膏订单</span>
            </el-menu-item>
            <el-menu-item index="5">
              <i class="el-icon-menu"></i>
              <span slot="title">国匠酒业</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <!-- <router-view></router-view> -->
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </el-main>
      </el-container>
      <el-dialog title="修改密码" :visible.sync="isModify" width="30%" :before-close="handleClose">
        <el-form ref="moneyform" label-width="120px" style="width:80%;">
          <el-form-item label="原始密码">
            <el-input v-model="modifyInfo.oldPasswd" placeholder="请输入原始密码" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="modifyInfo.newPasswd" placeholder="请输入新密码" type="password" show-password></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isModify = false" size="medium">取 消</el-button>
          <el-button type="primary" @click="doModifyPsw" size="medium">确定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import api from '../../services/index/api.js'
  import cookie from '../../common/cookie.js'
  export default {
    name: 'index',
    data() {
      return {
        activeIndex: cookie.get('activeIndex') ? cookie.get('activeIndex') : '1',
        asideHeight: '600px',
        isModify: false,
        modifyInfo: {
          newPasswd: '',
          oldPasswd: ''
        }
      }
    },

    computed: {
      ...mapGetters([
        'user',
        'baseUrl'
      ])
    },
    created() {
      let windowHeight = window.document.documentElement.clientHeight;
      this.asideHeight = windowHeight - 60 + 'px';
      if (this.activeIndex == 1) {
        this.$router.replace('/index/wx-delivery')
      } else if (this.activeIndex == 2) {
        this.$router.replace('/index/zbz-delivery')
      } else if (this.activeIndex == 3) {
        this.$router.replace('/index/jx-delivery')
      } else if (this.activeIndex == 4) {
        this.$router.replace('/index/top-delivery')
      } else if (this.activeIndex == 5) {
        this.$router.replace('/index/gj-delivery')
      }
    },
    watch: {
      //监听路由变化
      $route(to, from) {
        // console.log(to, from)
      }
    },
    methods: {
      handleClose() {},
      menuSelected(index) {
        if (this.activeIndex != index) {
          this.activeIndex = index
          cookie.set('activeIndex', index)
          if (index == 1) {
            this.$router.replace('/index/wx-delivery')
          } else if (index == 2) {
            this.$router.replace('/index/zbz-delivery')
          } else if (index == 3) {
            this.$router.replace('/index/jx-delivery')
          } else if (index == 4) {
            this.$router.replace('/index/top-delivery')
          } else if (index == 5) {
            this.$router.replace('/index/gj-delivery')
          }
        }
      },
      modifyPsw() {
        this.isModify = true
      },
      doModifyPsw() {
        if (!this.modifyInfo.oldPasswd) {
          this.$message('请输入原始密码')
          return
        }
        if (!this.modifyInfo.newPasswd) {
          this.$message('请输入新密码')
          return
        }
        api.modifyPsw(this.modifyInfo).then((res) => {
          this.isModify = false
          this.$message.success('修改成功')
          this.modifyInfo = {
            newPasswd: '',
            oldPasswd: ''
          }
        })
      },
      exitSystem() {
        this.$alert('该操作将清楚登录信息，是否继续？', '退出登录', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              cookie.removeToken()
              this.$router.replace('/login')
            }
          }
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    ul {
      margin-block-start: 0em;
      margin-block-end: 0em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 0px;
      width: 100% !important;

      .el-menu-item {
        margin: 0px !important;
        width: 100% !important;
        display: flex;
        align-items: center;
        padding: 0 20px;
      }
    }

    .header {
      padding: 0 0.4rem;
      background: #303133;
      justify-content: space-between;
      align-items: center;
      color: #FFFFFF;

      .i-title {
        font-size: 0.5rem;
        font-weight: bold;
      }

      .userName {
        font-size: 0.32rem;
      }

      .exit {
        margin-left: 0.2rem;
        font-size: 0.32rem;
        color: white;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue